import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { filterCommonAttributes } from '../ai-answer-dialog/analytics-helpers';
import type { commonAttributesType } from '../ai-answer-dialog/types';
import type { PersonKnowledgeCardVariant } from './on-person-knowledge-card-loaded';

interface PersonKnowledgeCardErroredProps extends commonAttributesType {
	personCardVariant: PersonKnowledgeCardVariant;
	errorMessage?: string;
}

export const onPersonKnowledgeCardErrored = (
	props: PersonKnowledgeCardErroredProps,
): AnalyticsEventPayload => {
	const { source, personCardVariant, errorMessage } = props;
	return {
		action: 'errored',
		actionSubject: 'aiAnswerPersonKnowledgeCard',
		source,
		eventType: 'operational',
		attributes: {
			...filterCommonAttributes(props),
			personCardVariant,
			errorMessage,
		},
	};
};
